import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { Notification } from "ng/src/app/notifications/notification.model";
import { NotificationService } from "../notification.service";
import { Subscription } from "rxjs";
import { Utils } from "ng/src/app/core/utils";
import { Table } from "primeng/table";
import { PrimeNGHelpersService } from "../../core/services/primeng-helpers.service";

@Component({
	selector: 'notification-list',
	templateUrl: './notification-list.component.html',
	styleUrls: ['./notification-list.component.css']
})
export class NotificationListComponent implements OnInit, OnDestroy {
	
	@ViewChild('table') table?: Table

	@Output()
	onNotificationSelected = new EventEmitter<Notification.Projections.WithLogName>();

	notifications: Notification.Projections.WithLogName[] = [];
	isLoading = false;
	_selectedNotification?: Notification.Projections.WithLogName;
	subs = new Subscription();
	get selectedNotification() {
		return this._selectedNotification;
	}
	set selectedNotification(val: Notification.Projections.WithLogName | undefined) {
		if (val === this._selectedNotification) return;
		this.openNotification(val);
	}

	constructor(public notificationService: NotificationService, private cdRef: ChangeDetectorRef) { }

	ngOnInit() {
		// set current notification if provided one in the url params
		this.notificationService.getFromRoute().subscribe(n => this._selectedNotification = n);

		this.subs.add(this.notificationService.notifications$.subscribe(n => {
			this.mergeNotifications(n, false);
			this.cdRef.detectChanges();
			setTimeout(() => {
				// Uses setTimeout to wait for the table to be rendered if notifications do exist.
				if (this.table) {
					PrimeNGHelpersService.disableDeselectionOfRow(this.table);
				}
			})
		}));
		this.subs.add(this.notificationService.isLoading$.subscribe(isLoading => {
			this.isLoading = isLoading;
			this.cdRef.detectChanges();
		}));
	}

	openNotification(notification?: Notification.Projections.WithLogName) {
		if (notification) {
			this._selectedNotification = notification;
			this.markRead(notification);
			this.onNotificationSelected.emit(notification);
		}
	}

	markRead(notification: Notification.Projections.WithLogName) {
		if (notification.seen) return; // nothing to do

		notification.seen = true;
		notification.toastSeen = true;
		this.notificationService.updateSeen(notification, 'both');
	}
	
	next() {
		if (!this.selectedNotification) return; // nothing to do

		const ix = this.notifications.findIndex(n => n.id === this.selectedNotification!.id);
		const next = this.notifications[ix + 1];
		if (next) {
			this.openNotification(next);
		}
	}

	previous() {
		if (!this.selectedNotification) return; // nothing to do

		const ix = this.notifications.findIndex(n => n.id === this.selectedNotification!.id);
		const prev = this.notifications[ix - 1];
		if (prev) {
			this.openNotification(prev);
		}
	}
	
	private mergeNotifications(newNotifications: Notification.Projections.WithLogName[], constrainEnd: boolean = false) {
		// if notifications were deleted, just start over and don't bother merging.
		if (newNotifications.length < this.notifications.length) {
			this.notifications = newNotifications;
			return;
		}

		let lastNotification = this.notifications[this.notifications.length - 1];
		
		newNotifications.forEach((notification) => {
			let index = this.notifications.findIndex(n => n.id === notification.id);
			
			// Replace notification if IDs match
			if (index >= 0)
				Object.assign(this.notifications[index], notification);
			else
				this.notifications.push(notification);
		});
		
		this.notifications.sort(Utils.createSortFunction(n => new Date(n.created), 'desc'));
		
		// Removes new notifications after the original oldest stored notification
		if (constrainEnd && lastNotification) {
			let splitIndex = this.notifications.findIndex(n => n.id === lastNotification.id);
			if (splitIndex >= 0)
				this.notifications.splice(splitIndex + 1);
		}
	};

	ngOnDestroy() {
		this.subs.unsubscribe();
	}
}